<template>
  <auth-template>
    <b-col md="8">
      <b-card-group>
        <b-card no-body class="p-4">
          <b-card-body>
              <h2>Inscrição indisponível.</h2>
          </b-card-body>
        </b-card>
      </b-card-group>
    </b-col>
  </auth-template>
</template>

<script>
import AuthTemplate from '@/templates/auth/AuthTemplate'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  name: 'SucessoCadastroPalestrante',
  components: {
    AuthTemplate
  },
  data () {
    return {
    }
  },
  methods: {
    voltarPortal () {
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/auth/InscricaoIndisponivel.vue